<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-toggle auto-hide="false">
            <img src="../assets/svg/logo-toolbar.svg">
            <!-- <ion-button>
              <ion-icon slot="icon-only" name="menu"></ion-icon>
            </ion-button> -->
          </ion-menu-toggle>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button class="btn-back" @click="$router.push('/home')">Back</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <ion-grid>

        <ion-row class="row-boxed mt-20">
          <ion-col size="12" v-if="yachts.length == 0">
            No yacht entered
          </ion-col>
          <ion-col size-xs="12" size-md="4" v-for="(y,i) in yachts" v-bind:key="'yachts-'+i">
            <div class="yachts-box">
              <span @click="() => deleteYacht(y)" v-if="$store.state.user_role != 'client'">-</span>
              <div class="yachts-box-title" @click="$router.push({ name: 'yatch-details', params: { id: y.id } })">{{ y.name }}</div>
              <div class="yachts-box-img" @click="$router.push({ name: 'yatch-details', params: { id: y.id } })">
                <img :src="y.img ? y.img : 'https://via.placeholder.com/1920x1080?text=IMAGE'">
              </div>
            </div>
          </ion-col>
        </ion-row>

      </ion-grid>
      <loader :visible="loader"></loader>
    </ion-content>
  </ion-page>
</template>

<script>
import axios from "axios"
export default {
  name: "YachtList",
  data: function() {
    return {
      yachts: [],
      loader: true,
    }
  },
  methods: {
    deleteYacht: function(yacht) {
      return this.$ionic.alertController
      .create({
        header: 'Delete yacht',
        message: 'Are you sure to delete ' + yacht.name + '?',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel'
          },
          {
            text: 'Confirm',
            handler: () => {
              this.loader = true
              axios.post(this.apiUrl + '/api/v1/delete-yacht', { api_token: this.$store.state.api_token, id: yacht.id })
              .then( () => {
                this.getYacht()
              })
            },
          },
        ],
      })
      .then(a => a.present())
    },
    getYacht: function() {
      axios.post(this.apiUrl + '/api/v1/get-yachts', { api_token: this.$store.state.api_token })
      .then((response) => {
        let res = response.data
        if(res.data.length) {
          this.yachts = res.data
        } else {
          this.yachts = []
        }
        this.loader = false;
      })
    }
  },
  mounted: function() {
    this.getYacht()
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.yachts-box {
  background-color: #D1D3D4;
  cursor: pointer;
  margin-bottom: 5px;
  position: relative;
}

.yachts-box-title {
  text-align: center;
  padding: 10px;
  font-size: 18px;
}

.yachts-box-img {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
  position: relative;
}
.yachts-box-img img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}

.yachts-box-img::before {
  content: '';
  display: block;
  padding-top: 56.25%;
}

.yachts-box > span {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 20px;
  height: 20px;
  background-color: var(--ion-color-primary);
  border-radius: 4px;
  color: #fff;
  text-align: center;
  cursor: pointer;
}

</style>